(function () {
  const ROOT_SELECTOR = '[data-bee-native-slideshow]';
  const instances = new WeakMap();

  function parseOptions(root) {
    try {
      return JSON.parse(root.getAttribute('data-bee-native-slideshow') || '{}');
    } catch (error) {
      return {};
    }
  }

  function toBool(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function esc(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  class BeeNativeSlideshow {
    constructor(root) {
      this.root = root;
      this.options = parseOptions(root);
      this.id = this.options.beeid || '';
      this.section = root.closest('.bee-section-inner') || root.parentElement;
      this.index = 0;
      this.offsets = [];
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.dragging = false;
      this.dragMoved = false;
      this.directionLocked = false;
      this.horizontalDrag = false;
      this.autoplayTimer = null;
      this.resizeTimer = null;
      this.inViewport = !('IntersectionObserver' in window);
      this.hovered = false;
      this.init();
    }

   init() {
  this.root.classList.add('flickitybee-enabled', 'bee-enabled', 'is-draggable');
  this.buildStructure();
  this.collectSlides();
  this.bindControls();
  this.createDots();
  this.bindDrag();
  this.bindHover();
  this.bindResize();
  this.bindVisibility();
  this.measure();
  this.select(this.getStartIndex(), false);
  this.root.classList.add('is-native-ready');
  this.startAutoplay();
}

    buildStructure() {
  const oldViewport = Array.from(this.root.children).find(el => el.classList.contains('flickitybee-viewport'));

  if (oldViewport) {
    this.viewport = oldViewport;
    this.track = oldViewport.querySelector('.flickitybee-slider');

    this.viewport.style.height = 'auto';
    this.viewport.style.overflow = 'hidden';
    this.viewport.style.position = 'relative';

    this.track.style.position = 'relative';
    this.track.style.display = 'flex';
    this.track.style.height = 'auto';
    this.track.style.touchAction = 'pan-y';
    this.track.style.cursor = 'grab';
    this.track.style.willChange = 'transform';
    this.track.style.transition = 'none';

    return;
  }

  const slides = Array.from(this.root.children).filter(el => {
    return el.classList.contains('bee-slideshow-item') || el.hasAttribute('data-select-flickity');
  });

  this.viewport = document.createElement('div');
  this.viewport.className = 'flickitybee-viewport';
  this.viewport.style.height = 'auto';
  this.viewport.style.overflow = 'hidden';
  this.viewport.style.position = 'relative';
  this.viewport.style.width = '100%';

  this.track = document.createElement('div');
  this.track.className = 'flickitybee-slider';
  this.track.style.position = 'relative';
  this.track.style.display = 'flex';
  this.track.style.width = '100%';
  this.track.style.height = 'auto';
  this.track.style.touchAction = 'pan-y';
  this.track.style.cursor = 'grab';
  this.track.style.willChange = 'transform';
  this.track.style.transition = 'none';

  slides.forEach(slide => this.track.appendChild(slide));
  this.viewport.appendChild(this.track);
  this.root.insertBefore(this.viewport, this.root.firstChild);
}

    collectSlides() {
      this.slides = Array.from(this.track.children).filter(el => {
        return el.classList.contains('bee-slideshow-item') || el.classList.contains('bee-col-item');
      });
      this.maxIndex = Math.max(0, this.slides.length - 1);
    }

    bindControls() {
      const prevSelector = this.id ? `.btn__prev--${esc(this.id)}` : '.flickitybee-prev-next-button.previous';
      const nextSelector = this.id ? `.btn__next--${esc(this.id)}` : '.flickitybee-prev-next-button.next';

      this.prevButtons = Array.from(this.section.querySelectorAll(prevSelector));
      this.nextButtons = Array.from(this.section.querySelectorAll(nextSelector));

      if (toBool(this.options.prevNextButtons) && this.prevButtons.length === 0 && this.nextButtons.length === 0) {
        const prev = this.createButton('previous');
        const next = this.createButton('next');
        this.root.appendChild(prev);
        this.root.appendChild(next);
        this.prevButtons = [prev];
        this.nextButtons = [next];
      }

      this.prevButtons.forEach(btn => btn.addEventListener('click', e => {
        e.preventDefault();
        this.prev();
      }));

      this.nextButtons.forEach(btn => btn.addEventListener('click', e => {
        e.preventDefault();
        this.next();
      }));
    }

    createButton(type) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `flickitybee-button flickitybee-prev-next-button ${type} bee-d-inline-flex`;
      btn.setAttribute('aria-label', type === 'previous' ? 'Previous' : 'Next');
      btn.innerHTML = type === 'previous'
        ? '<svg class="flickitybee-button-icon" viewBox="0 0 22 22"><path d="M14,18c-.26,0-.51-.1-.71-.29L6.59,11l6.71-6.71c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41L9.41,11l5.29,5.29c.39,.39,.39,1.02,0,1.41-.19,.19-.44,.29-.7,.29z"></path></svg>'
        : '<svg class="flickitybee-button-icon" viewBox="0 0 22 22"><path d="M8,18c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L12.59,11,7.29,5.71c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0L15.41,11l-6.71,6.71c-.19,.19-.44,.29-.7,.29z"></path></svg>';
      return btn;
    }

    createDots() {
      if (!toBool(this.options.pageDots)) return;

      this.dotsWrap = this.root.querySelector('.flickitybee-page-dots');

      if (!this.dotsWrap) {
        this.dotsWrap = document.createElement('ol');
        this.dotsWrap.className = 'flickitybee-page-dots';
        this.root.appendChild(this.dotsWrap);
      }

      this.dotsWrap.innerHTML = '';
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('li');
        dot.className = 'dot';
        dot.setAttribute('aria-label', `Slide ${index + 1}`);
        dot.addEventListener('click', () => this.select(index, true));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
    }

    bindDrag() {
      this.track.addEventListener('pointerdown', e => this.onPointerDown(e));
      this.track.addEventListener('pointermove', e => this.onPointerMove(e));
      this.track.addEventListener('pointerup', e => this.onPointerUp(e));
      this.track.addEventListener('pointercancel', e => this.onPointerUp(e));
      this.track.addEventListener('lostpointercapture', e => this.onPointerUp(e));

      this.track.addEventListener('click', e => {
        if (!this.dragMoved) return;
        e.preventDefault();
        e.stopPropagation();
        this.dragMoved = false;
      }, true);
    }

    bindHover() {
      if (!toBool(this.options.pauseAutoPlayOnHover)) return;
      this.root.addEventListener('mouseenter', () => {
        this.hovered = true;
        this.stopAutoplay();
      });
      this.root.addEventListener('mouseleave', () => {
        this.hovered = false;
        this.startAutoplay();
      });
    }

    bindVisibility() {
      this.visibilityHandler = () => this.startAutoplay();
      document.addEventListener('visibilitychange', this.visibilityHandler);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.inViewport = entry.isIntersecting;
          this.startAutoplay();
        });
        this.visibilityObserver.observe(this.root);
      }
    }

    bindResize() {
      this.resizeHandler = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.measure();
          this.select(this.index, false);
        }, 120);
      };
      window.addEventListener('resize', this.resizeHandler);
    }

    onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;

      this.dragging = true;
      this.dragMoved = false;
      this.directionLocked = false;
      this.horizontalDrag = false;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.prevTranslate = this.currentTranslate;

      this.track.style.transition = 'none';
      this.track.style.cursor = 'grabbing';
      this.stopAutoplay();

      if (this.track.setPointerCapture) this.track.setPointerCapture(e.pointerId);
      this.raf = requestAnimationFrame(() => this.animateDrag());
    }

    onPointerMove(e) {
      if (!this.dragging) return;

      const diffX = e.clientX - this.startX;
      const diffY = e.clientY - this.startY;

      if (!this.directionLocked && (Math.abs(diffX) > 2 || Math.abs(diffY) > 2)) {
        this.directionLocked = true;
        this.horizontalDrag = Math.abs(diffX) >= Math.abs(diffY);
      }

      if (!this.horizontalDrag) return;

      e.preventDefault();
      this.dragMoved = Math.abs(diffX) > 4;
      this.currentTranslate = this.applyEdgeResistance(this.prevTranslate + diffX);
    }

    onPointerUp(e) {
      if (!this.dragging) return;

      this.dragging = false;
      cancelAnimationFrame(this.raf);

      if (this.track.releasePointerCapture) {
        try {
          this.track.releasePointerCapture(e.pointerId);
        } catch (error) {}
      }

      const moved = this.currentTranslate - this.prevTranslate;
      const threshold = Math.min(70, Math.max(34, this.root.clientWidth * 0.08));

      if (moved < -threshold) {
        this.next();
      } else if (moved > threshold) {
        this.prev();
      } else {
        this.select(this.index, true);
      }

      this.track.style.cursor = 'grab';
      this.startAutoplay();
    }

    animateDrag() {
      this.setTranslate(this.currentTranslate);
      if (this.dragging) this.raf = requestAnimationFrame(() => this.animateDrag());
    }

    applyEdgeResistance(value) {
      if (toBool(this.options.wrapAround)) return value;

      const first = this.offsets[0] || 0;
      const last = this.offsets[this.maxIndex] || 0;

      if (value > first) return first + (value - first) * 0.28;
      if (value < last) return last + (value - last) * 0.28;

      return value;
    }
   getStartIndex() {
  if (!this.slides || this.slides.length < 3) return 0;

  return 1;
}

    measure() {
      if (!this.slides.length) return;

      this.track.style.transition = 'none';

      const viewportWidth = this.viewport.clientWidth || this.root.clientWidth;

      this.offsets = this.slides.map(slide => {
        return viewportWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);
      });

      this.maxIndex = Math.max(0, this.slides.length - 1);
    }

    select(index, animate) {
      if (!this.slides.length) return;

      if (toBool(this.options.wrapAround)) {
        if (index < 0) index = this.maxIndex;
        if (index > this.maxIndex) index = 0;
      } else {
        index = clamp(index, 0, this.maxIndex);
      }

      this.index = index;

      const target = this.offsets[index] || 0;

      this.track.style.transition = animate
        ? 'transform 460ms cubic-bezier(.22,.61,.36,1)'
        : 'none';

      this.currentTranslate = target;
      this.prevTranslate = target;
      this.setTranslate(target);

      this.updateSelected();
      this.updateDots();
      this.updateButtons();
      this.updateNumbers();
      this.updateHeight();
    }

    setTranslate(value) {
      this.track.style.transform = `translate3d(${value}px,0,0)`;
    }

    updateSelected() {
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-selected', index === this.index);
        slide.setAttribute('aria-hidden', index === this.index ? 'false' : 'true');
      });
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-selected', index === this.index);
      });
    }

    updateButtons() {
      if (toBool(this.options.wrapAround)) {
        this.prevButtons.forEach(btn => btn.disabled = false);
        this.nextButtons.forEach(btn => btn.disabled = false);
        return;
      }

      this.prevButtons.forEach(btn => btn.disabled = this.index === 0);
      this.nextButtons.forEach(btn => btn.disabled = this.index >= this.maxIndex);
    }

    updateNumbers() {
      if (!this.id) return;

      const status = this.section.querySelector(`.carousel--status${esc(this.id)}`);
      if (!status) return;

      const current = status.querySelector('[data-current-slide]');
      const total = status.querySelector('[data-total-number]');
      const pad = toBool(this.options.pad);

      const currentText = pad ? String(this.index + 1).padStart(2, '0') : String(this.index + 1);
      const totalText = pad ? String(this.slides.length).padStart(2, '0') : String(this.slides.length);

      if (current) current.textContent = currentText;
      if (total) total.textContent = totalText;
    }

    updateHeight() {
      if (!toBool(this.options.adaptiveHeight)) return;

      const selected = this.slides[this.index];
      if (selected) this.viewport.style.height = `${selected.offsetHeight}px`;
    }

    prev() {
      this.select(this.index - 1, true);
    }

    next() {
      this.select(this.index + 1, true);
    }

    startAutoplay() {
      const delay = parseInt(this.options.autoPlay, 10);
      this.stopAutoplay();
      if (!delay || delay <= 0 || this.slides.length < 2 || document.hidden ||
          !this.inViewport || this.hovered || this.dragging || !this.root.isConnected) return;

      this.autoplayTimer = setInterval(() => {
        if (!toBool(this.options.wrapAround) && this.index >= this.maxIndex) {
          this.select(0, true);
        } else {
          this.next();
        }
      }, delay);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    destroy() {
      this.stopAutoplay();
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.raf);
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(root => {
      if (instances.has(root)) return;
      instances.set(root, new BeeNativeSlideshow(root));
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(root => {
      const instance = instances.get(root);
      if (instance) instance.destroy();
      instances.delete(root);
    });
  });
})();
